module.exports = __webpack_public_path__ + "img/analytics-marketing-team-5.dc537a2c.svg";